export default __webpack_public_path__ + "static/media/flag-mg.9af4dc01.svg";